
function isEmpty(obj: any) {
    return obj == null || (typeof obj === 'object' && Object.keys(obj).length === 0);
}
export function emptify(obj: any, property?: string) {
    if (obj == null || typeof obj !== 'object') return;
    if (!property) {
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                emptify(obj, key);
            }
        }
    } else {
        emptify(obj[property]);        
        if (isEmpty(obj[property]))
            delete obj[property];
    }
}